import { render, staticRenderFns } from "./ChainSelection.vue?vue&type=template&id=5dac0396&"
import script from "./ChainSelection.vue?vue&type=script&lang=js&"
export * from "./ChainSelection.vue?vue&type=script&lang=js&"
import style0 from "./ChainSelection.vue?vue&type=style&index=0&id=5dac0396&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports